import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { isAppWebView, isDesktopView } from '../utils/app/web-view/index.js';
import { M as METADATA_VIEWPORT_WEBVIEW, a as METADATA_SITE_LOCALE, b as METADATA_VIEWPORT_DESKTOPVIEW, c as METADATA_VIEWPORT } from './constants-BUvZeSVk.js';

const PageMeta = ({ platform, view, }) => {
    const viewport = isDesktopView(view)
        ? METADATA_VIEWPORT_DESKTOPVIEW
        : METADATA_VIEWPORT;
    return (jsxs(Fragment, { children: [jsx("meta", { content: isAppWebView(platform)
                    ? METADATA_VIEWPORT_WEBVIEW
                    : viewport, name: "viewport" }), jsx("meta", { content: METADATA_SITE_LOCALE, httpEquiv: "content-language" }), jsx("meta", { content: "text/html; charset=utf-8", httpEquiv: "content-type" })] }));
};

export { PageMeta as P };
//# sourceMappingURL=component-CFZ63ygZ.js.map
